import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Modal } from 'synfrastructure';
import numeral from 'numeral';
import moment from 'moment';
import UpdateBillingContent from '../../../common/components/UpdateBillingContent';
import { enrollCourse, resetCourseEnrollment } from '../redux/actions';
import { selectDefaultSource } from '../../redux/selectors';

class CourseEnrollModal extends Component {
  static propTypes = {
    course: PropTypes.object.isRequired,
    nextChapterId: PropTypes.number.isRequired,
  };
  state = {
    modalVisible: false,
  };
  componentWillUnmount() {
    this.props.dispatch(resetCourseEnrollment());
  }
  handleEnroll = () => {
    const { course, dispatch, history, nextChapterId } = this.props;
    dispatch(enrollCourse(course.id)).then(payload => {
      if (payload.response.ok) {
        history.push(`/subscription/courses/${course.id}/chapters/${nextChapterId}`);
      }
    });
  };
  handleToggleModal = () => {
    const { course } = this.props;
    if (!this.state.modalVisible && course.price === 0) {
      // This course is free, enroll in the background and push redirect
      this.handleEnroll();
    } else {
      this.setState((state, props) => ({
        modalVisible: !state.modalVisible,
      }));
    }
  };
  renderModalContents = () => {
    const { source, course, error } = this.props;

    if (
      source &&
      !error &&
      !moment({ year: source.get('exp_year'), month: source.get('exp_month') }).isBefore(moment().subtract(1, 'months'))
    ) {
      return (
        <div>
          <div className="modal__content">
            <h3>Purchase This Course</h3>
            <p>
              Your {source.get('brand')} ending in <strong>{source.get('last4')}</strong> will be charged{' '}
              <em>{numeral(course.price / 100).format('$0,0.00')}</em>
            </p>
          </div>
          <div className="modal__actions">
            <div className="button button--theme--plain" onClick={this.handleToggleModal}>
              Cancel
            </div>
            <button type="submit" className="button" onClick={this.handleEnroll}>
              Submit
            </button>
          </div>
        </div>
      );
    } else {
      return <UpdateBillingContent />;
    }
  };
  render() {
    const { enrolling } = this.props;
    return (
      <div className="purchase-course__modal">
        <button type="button" className="button" onClick={this.handleToggleModal}>
          Enroll
        </button>

        {
          <Modal isVisible={this.state.modalVisible} onClose={this.handleToggleModal}>
            {enrolling ? <div /> : this.renderModalContents()}
          </Modal>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    source: selectDefaultSource(state),
    enrolling: state.subscription.courses.enrollCourse.get('loading'),
    error: state.subscription.courses.enrollCourse.get('error'),
  };
};

export default withRouter(connect(mapStateToProps)(CourseEnrollModal));



// WEBPACK FOOTER //
// ./src/subscription/courses/components/CourseEnrollModal.js